export default __webpack_public_path__ + "5fffabcc93b96f59d3bc7458eeb5c362.png";